import { create } from "zustand"

interface LocationDialogState {
  isOpen: boolean
  setIsOpen: (open: boolean) => void
  triggerSource: "header" | "menu" | null
  setTriggerSource: (source: "header" | "menu" | null) => void
}

export const useLocationDialogStore = create<LocationDialogState>((set) => ({
  isOpen: false,
  setIsOpen: (open) => set({ isOpen: open }),
  triggerSource: null,
  setTriggerSource: (source) => set({ triggerSource: source }),
}))
